import React, { Component } from 'react'
import Link from 'gatsby-link'
import bradLogo from '../images/BradLogo.png'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'

class NavBar extends Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false,
    }
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    return (
      <div>
        <Navbar className="navbar-teal" light expand="md">
          <NavbarBrand href="/">
            <img
              src={bradLogo}
              alt="Brad Hankee"
              className="hankeeLogo my-auto "
            />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem className="nav-item active my-auto">
                <NavLink href="/">
                  <span>HOME</span>
                </NavLink>
              </NavItem>
              <NavItem className="nav-item active my-auto">
                <NavLink href="/resume">
                  <span>RESUME</span>
                </NavLink>
              </NavItem>
              <NavItem className="nav-item active my-auto">
                <a href="https://medium.com/code-a-la-carte" target="_blank">
                  <span>BLOG</span>
                </a>
              </NavItem>
              <NavItem />
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}
export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar.js